<div class="flex justify-between w-full">
  <div class="flex">
    <div class="i-black-marker"></div>
    <div class="ml-3 flex flex-col">
      <div class="font-bold">
        {{(model?.isGiven ? 'handover.report-title-given' : 'handover.report-title-return') | translate}} {{this.model?.uniqueNumber}}
      </div>
      <div *ngIf="model?.clientData else noClientDataTemp" class="tk-c-gray grid">
        <div *ngFor="let item of model?.clientData">{{item}}</div>
      </div>
      <ng-template #noClientDataTemp>
        {{'handover.empty-field' | translate}}
      </ng-template>
    </div>
  </div>

  <div *ngIf="model?.place else noPlaceTemp" class="tk-c-gray">
    {{model?.place}} {{model?.date | date:'medium'}}
  </div>
  <ng-template #noPlaceTemp>
    {{'handover.empty-field' | translate}}
  </ng-template>
</div>
